module.exports = __webpack_public_path__ + "static/media/divM_final_500.6b167c8d.jpg";